import { subDays as subDaysFn } from 'date-fns'

export const subDays = ({
  days,
}: {
  days: number;
}) => (
  subDaysFn(new Date(), days).toISOString()
)
